import { render, staticRenderFns } from "./SupervisedSummary.vue?vue&type=template&id=580080e0&scoped=true&"
import script from "./SupervisedSummary.vue?vue&type=script&lang=js&"
export * from "./SupervisedSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580080e0",
  null
  
)

export default component.exports